import React, { useEffect, useState } from "react";
import { isMobileView, isTabletView } from '../utils/deviceUtils';
import recipeCardStyles from '../components/RecipeCard.module.css';
import { Link} from "react-router-dom";
import "./home.css"; 
import { api } from '../api/client';
import FoodScrollAnimation from '../components/FoodScrollAnimation';
import MaggieWithFood from '../assets/maggie.jpeg';
import pawImg from '../assets/paw.png';
import Maggie1 from '../assets/magPink.jpg';
import Maggie2 from '../assets/maggieF.jpg';
import Maggie3 from '../assets/maggie.jpg';
import MaggieRiceChicken from '../assets/Chicken-Rice-Comfort-Bowl-maggie.jpg';
import MaggieSweetPotato from '../assets/Chicken-Sweet-Potato-Nourish-Bowl-maggie-2.jpg';
import MaggieBeefPumpkin from '../assets/Hearty-Beef-Pumpkin-Stew-maggie.jpg';
import MaggieTurkeyPumpkin from '../assets/Turkey-pumpkin-simple-bowl-maggie.png';
import MeAndMaggie1 from '../assets/maggie-me-first.JPG';
import MeAndMaggie2 from '../assets/maggie-and-me-2.JPG';
import MaggieFood from '../assets/maggie-with-food-5.jpg';
import LillyMaggie from '../assets/lillymagie.jpg';
import Lilly from '../assets/lilly.jpg';
import { useNavigate } from "react-router-dom";
import buttonStyles from '../components/Buttons.module.css';
import { BACKEND_URL } from '../config';
import { ReactComponent as DogIcon } from '../assets/icons/dog.svg';
import { ReactComponent as ForkKnifeIcon } from '../assets/icons/fork-knife.svg';
import { ReactComponent as ChartBarIcon } from '../assets/icons/chart-bar.svg';
import { useAuth } from '../auth/AuthContext';
import { isRecipeLocked } from '../utils/recipeAccess';
import { isPremium, isAdmin } from '../utils/userAccess';

interface Recipe {
  id: number;
  slug: string;
  title: string;
  description?: string;
  instructions?: string;
  user_id?: number;
  created_at?: string;
  updated_at?: string;
  photo_url: string;
  base_yield_grams?: number;
  ingredients?: any[];
  locked?: boolean;
  unlocked?: boolean;
  is_locked?: boolean;
  access?: string;
}

// TODO add ant skeleton 

const Home: React.FC = () => {
  const navigate = useNavigate();
  const { token, user } = useAuth();

  // Define heroImages as a constant outside of render or memoize it
  const heroImages = React.useMemo(() => [
    MaggieWithFood,
    MeAndMaggie1,
    MaggieRiceChicken,
    MeAndMaggie2,
    Maggie1,
    MaggieSweetPotato,
    Maggie2,
    Maggie3,
    LillyMaggie,
    Lilly,
    MaggieBeefPumpkin,
    MaggieTurkeyPumpkin,
    MaggieFood
  ], []);
  
  const [carouselIndex, setCarouselIndex] = useState(0);

  // Preload all carousel images on mount for better performance
  useEffect(() => {
    heroImages.forEach((imageSrc) => {
      const img = new Image();
      img.src = imageSrc;
    });
  }, [heroImages]); // Include heroImages in dependency array

  useEffect(() => {
    const interval = setInterval(() => {
      setCarouselIndex((prev) => (prev + 1) % heroImages.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [heroImages.length]);
  
  const [recipes, setRecipes] = useState<Recipe[]>([]);
  // const [showStickyButton, setShowStickyButton] = useState(false);

  useEffect(() => {
    const fetchRecipes = async () => {
      try {
        const response = await api.get('/recipes');
        setRecipes(response.data);
      } catch (error) {
        console.error('Error fetching recipes:', error);
      }
    };

    fetchRecipes();
  }, []);

  // Scroll to recipes section when returning from recipe detail
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const shouldScroll = params.get('scrollToRecipes');
    
    if (shouldScroll === 'true') {
      // Small delay to ensure the page has fully rendered
      setTimeout(() => {
        const recipesSection = document.getElementById('recipes-we-love');
        if (recipesSection) {
          recipesSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
      
      // Clean up the URL parameter
      params.delete('scrollToRecipes');
      const newUrl = params.toString() ? `?${params.toString()}` : window.location.pathname;
      window.history.replaceState({}, '', newUrl);
    }
  }, []);

  return (
    <div className="home-container">
      <div className="hero-section-wrapper">
        {/* Animated floating paw prints background - fade or hide on mobile/tablet */}
        {!(isMobileView() || isTabletView()) && (
          <div className="hero-paw-bg">
            <img src={pawImg} className="hero-paw-float paw1" alt="" />
            <img src={pawImg} className="hero-paw-float paw2" alt="" />
            <img src={pawImg} className="hero-paw-float paw3" alt="" />
            <img src={pawImg} className="hero-paw-float paw4" alt="" />
            <img src={pawImg} className="hero-paw-float paw5" alt="" />
            <img src={pawImg} className="hero-paw-float paw6" alt="" />
            <img src={pawImg} className="hero-paw-float paw7" alt="" />
          </div>
        )}
        <div className="hero-engage">
          {/* Mobile/tablet: carousel inside hero-content; desktop: two columns */}
          {isMobileView() || isTabletView() ? (
            <div className="hero-content">
              <h1 className="hero-title">
                Cook Healthy Meals for Your Dog With What You Already Have
              </h1>
              <div className="hero-trust-badge">
                <span role="img" aria-label="shield" className="hero-shield-icon">🛡️</span>
                Safe for Dogs
              </div>
              <div className="hero-tagline accent-tagline">
                Healthy, Homemade, Safe
              </div>
              <p className="hero-desc">
                Turn leftovers into nutritious dog meals. Easy, fun, and pup-approved!
              </p>
              <div className="hero-image-wrap carousel">
                <img
                  src={heroImages[carouselIndex]}
                  alt={`Dog hero ${carouselIndex + 1}`}
                  className="hero-image carousel-image"
                />
                <div className="carousel-dots">
                  {heroImages.map((_, idx) => (
                    <span
                      key={idx}
                      className={`carousel-dot${carouselIndex === idx ? ' active' : ''}`}
                      onClick={() => setCarouselIndex(idx)}
                    />
                  ))}
                </div>
              </div>
              <div className="hero-cta-row">
                <Link to="/recipe-builder">
                  <button className={`${buttonStyles.largeBtn} ${buttonStyles.antBtnPrimary}`}> 
                    Get Started
                  </button>
                </Link>
                <Link to="#recipes-we-love" onClick={e => {
                  e.preventDefault();
                  const el = document.getElementById('recipes-we-love');
                  if (el) {
                    el.scrollIntoView({ behavior: 'smooth' });
                  }
                }}>
                  <button className={`${buttonStyles.largeBtn} ${buttonStyles.antBtnSecondaryHome}`}> 
                    Featured Recipes
                  </button>
                </Link>
              </div>
              <div className="hero-speed-subheading">
                Takes less than 1 minute to get a recipe
              </div>
            </div>
          ) : (
            <>
              <div className="hero-content">
                <h1 className="hero-title">
                  Cook Healthy Meals for Your Dog With What You Already Have
                </h1>
                <div className="hero-trust-badge">
                  <span role="img" aria-label="shield" className="hero-shield-icon">🛡️</span>
                  Safe for Dogs
                </div>
                <div className="hero-tagline accent-tagline">
                  Healthy, Homemade, Safe
                </div>
                <p className="hero-desc">
                  Turn leftovers into nutritious dog meals. Easy, fun, and pup-approved!
                </p>
                <div className="hero-cta-row">
                  <Link to="/recipe-builder">
                    <button className={`${buttonStyles.largeBtn} ${buttonStyles.antBtnPrimary}`}> 
                      Get Started
                    </button>
                  </Link>
                  <Link to="#recipes-we-love" onClick={e => {
                    e.preventDefault();
                    const el = document.getElementById('recipes-we-love');
                    if (el) {
                      el.scrollIntoView({ behavior: 'smooth' });
                    }
                  }}>
                    <button className={`${buttonStyles.largeBtn} ${buttonStyles.antBtnSecondaryHome}`}> 
                      Featured Recipes
                    </button>
                  </Link>
                </div>
                <div className="hero-speed-subheading">
                  Takes less than 1 minute to get a recipe
                </div>
              </div>
              <div className="hero-image-wrap carousel">
                {heroImages.map((imgSrc, idx) => (
                  <img
                    key={idx}
                    src={imgSrc}
                    alt={`Dog hero ${idx + 1}`}
                    className="hero-image carousel-image"
                    style={{
                      display: carouselIndex === idx ? 'block' : 'none',
                      position: carouselIndex === idx ? 'relative' : 'absolute',
                      opacity: carouselIndex === idx ? 1 : 0
                    }}
                  />
                ))}
                <div className="carousel-dots">
                  {heroImages.map((_, idx) => (
                    <span
                      key={idx}
                      className={`carousel-dot${carouselIndex === idx ? ' active' : ''}`}
                      onClick={() => setCarouselIndex(idx)}
                    />
                  ))}
                </div>
              </div>
            </>
          )}
        </div>
        {/* How it works section below hero - vertical card steps on mobile/tablet */}
        <div className="how-it-works-section">
          <h3 className="how-title">How It Works</h3>
          {(isMobileView() || isTabletView()) ? (
            <div className="how-steps-vertical">
              <div className="how-card-step" data-step="1"> Pick your ingredients</div>
              <div className="how-card-step" data-step="2"> Enter your dog's profile</div>
              <div className="how-card-step" data-step="3"> Get custom recipes</div>
              <div className="how-card-step" data-step="4"> Cook for your dog!</div>
            </div>
          ) : (
            <div className="how-steps">
              <span className="how-badge" data-step="1"> Pick your ingredients</span>
              <span className="how-arrow">&#10132;</span>
              <span className="how-badge" data-step="2"> Enter your dog's profile</span>
              <span className="how-arrow">&#10132;</span>
              <span className="how-badge" data-step="3"> Get custom recipes</span>
              <span className="how-arrow">&#10132;</span>
              <span className="how-badge" data-step="4"> Cook for your dog!</span>
            </div>
          )}
        </div>
      </div>
      <FoodScrollAnimation />

      {/* Educational Guides Section */}
      <div className="guides-container" style={{ 
        maxWidth: 1200, 
        margin: '4rem auto', 
        padding: '0 2rem' 
      }}>
        <h2 className="recipes-title">Learn About Homemade Dog Food</h2>
        <p style={{ 
          color: '#7a3a3a', 
          fontSize: '1.1rem', 
          textAlign: 'center', 
          marginBottom: '2.5rem',
          maxWidth: 700,
          marginLeft: 'auto',
          marginRight: 'auto'
        }}>
          Essential guides to help you safely feed homemade dog food
        </p>
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: isMobileView() || isTabletView() ? '1fr' : 'repeat(3, 1fr)', 
          gap: '2rem' 
        }}>
          <Link to="/transition-guide" className="home-guide-card">
            <h3 style={{ color: '#b24646', fontSize: '1.3rem', marginTop: 0, marginBottom: '0.8rem', fontWeight: 700, display: 'flex', alignItems: 'center', gap: '0.6rem' }}>
              <DogIcon style={{ width: '1.8rem', height: '1.8rem', fill: '#d97706', flexShrink: 0 }} />
              Transition Guide
            </h3>
            <p style={{ color: '#7a3a3a', fontSize: '1rem', lineHeight: 1.6, margin: 0, flexGrow: 1 }}>
              Learn how to safely transition your dog to homemade meals over 7-10 days
            </p>
            <span className="guide-arrow" style={{ color: '#d97706', fontSize: '1.5rem', alignSelf: 'flex-end', marginTop: '1rem' }}>→</span>
          </Link>
          <Link to="/feeding-portions" className="home-guide-card">
            <h3 style={{ color: '#b24646', fontSize: '1.3rem', marginTop: 0, marginBottom: '0.8rem', fontWeight: 700, display: 'flex', alignItems: 'center', gap: '0.6rem' }}>
              <ForkKnifeIcon style={{ width: '1.8rem', height: '1.8rem', fill: '#d97706', flexShrink: 0 }} />
              How Much to Feed
            </h3>
            <p style={{ color: '#7a3a3a', fontSize: '1rem', lineHeight: 1.6, margin: 0, flexGrow: 1 }}>
              Understand portion sizes based on your dog's weight, age, and body condition
            </p>
            <span className="guide-arrow" style={{ color: '#d97706', fontSize: '1.5rem', alignSelf: 'flex-end', marginTop: '1rem' }}>→</span>
          </Link>
          <Link to="/how-recipes-are-developed" className="home-guide-card">
            <h3 style={{ color: '#b24646', fontSize: '1.3rem', marginTop: 0, marginBottom: '0.8rem', fontWeight: 700, display: 'flex', alignItems: 'center', gap: '0.6rem' }}>
              <ChartBarIcon style={{ width: '1.8rem', height: '1.8rem', fill: '#d97706', flexShrink: 0 }} />
              How Recipes Are Developed
            </h3>
            <p style={{ color: '#7a3a3a', fontSize: '1rem', lineHeight: 1.6, margin: 0, flexGrow: 1 }}>
              Discover the nutritional principles behind our balanced recipes
            </p>
            <span className="guide-arrow" style={{ color: '#d97706', fontSize: '1.5rem', alignSelf: 'flex-end', marginTop: '1rem' }}>→</span>
          </Link>
        </div>
      </div>

      {/* Featured Recipes Section */}
      <div className="recipes-container" id="recipes-we-love">
        <h2 className="recipes-title">Featured Recipes</h2>
        <div className={recipeCardStyles.recipeGrid}>
          {recipes.slice(0, 8).map((recipe) => (
            <Link
              to={`/recipes/${recipe.slug}?from=home&scrollToRecipes=true`}
              key={recipe.id}
              className={recipeCardStyles.recipeCard}
            >
              <div>
                <img src={`${BACKEND_URL}${recipe.photo_url}`} alt={recipe.title} className={recipeCardStyles.recipeImage} />
              </div>
              <div className={recipeCardStyles.recipeTextContainer}>
                <h4 className={recipeCardStyles.recipeTitle}>{recipe.title}</h4>
                {recipe.description && (
                  <div className={recipeCardStyles.recipeDescription}>{recipe.description}</div>
                )}
                {token && isRecipeLocked(recipe) && !isPremium(user) && !isAdmin(user) && (
                  <div style={{ marginTop: 8, fontWeight: 700, color: '#b24646' }}>
                    Locked
                  </div>
                )}
              </div>
              <div>
                <button
                  className={`${buttonStyles.antBtn} ${buttonStyles.antBtnPrimary}`}
                  onClick={e => {
                    e.preventDefault();
                    navigate(`/recipes/${recipe.slug}?from=home&scrollToRecipes=true`);
                  }}
                >
                  View Recipe
                </button>
              </div>
            </Link>
          ))}
        </div>
      </div>
      {/* Floating Get Started button - commented out */}
      {/* {showStickyButton && !(isMobileView() || isTabletView()) && (
        <Link to="/recipe-builder">
          <button className={`${buttonStyles.getStartedFridgeBtn}`}>
            Get Started
          </button>
        </Link>
      )} */}
    </div>
  );
};

export default Home;